<template>
  <div class="sidebar">
    <el-menu
        class="sidebar-el-menu"
        :default-active="onRoutes"
        :collapse="collapse"
        background-color="#324157"
        text-color="#bfcbd9"
        active-text-color="#20a0ff"
        unique-opened
        router>
      <Page :items="items"/>
    </el-menu>
  </div>
</template>

<script lang="ts" setup>
import Page from "@/components/Page.vue";
import {computed, onMounted, ref} from "vue";
import {PageGroup} from "@/types/dto";
import {addRouter} from "@/router";
import {ElMessageBox} from "element-plus";
import {pageStore} from "@/store/pageStore";

const collapse = computed((): boolean => {
  return false;
});

const onRoutes = "/"
const dashboard: PageGroup = {
  page: "/dashboard",
  title: "系统首页",
  itemList: []
};
const items = ref<PageGroup[]>([
  dashboard
]);
onMounted(() => {
  pageStore().queryPage().then((data) => {
    items.value = [dashboard].concat(data);
    // 加入路由
    addRouter(data)
  }).catch(err => {
    ElMessageBox.alert("页面信息加载失败,请刷新页面重试", "错误");
  })
})
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
  text-align: left;
  background:#324157;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 200px;
}

.sidebar > ul {
  height: 100%;
}
</style>
